import { View } from "binder"
import { AccountGatewaySelectorViewModel } from "src/erp/arap/rawData/accountGatewaySelector-viewModel";
import { AccountGatewayViewModel } from "./accountGateway-viewModel"

export class AccountGatewayView extends View<AccountGatewayViewModel>{
    GetViewUniqueId(): string {
        return "V-93262474-4C15-49D9-A027-1AC29FD12207"
    }
    loadHtml(): string {
        let element = require('./accountGateway.html').default;
        let style = require('./accountGateway.less');
        return element;
    }
    constructor() {
       super();
    }

    public set accountSelector(v: AccountGatewaySelectorViewModel) { this._accountSelector = v; } public get accountSelector(): AccountGatewaySelectorViewModel { return this._accountSelector;} private _accountSelector: AccountGatewaySelectorViewModel;

}
